import React, { Component } from 'react';
import debounce from 'lodash/debounce';
import { Row, Col, FormControl, ControlLabel, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import SearchJobsPlaceHolder from './SearchJobsPlaceHolder';

class SearchJobs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: '',
      showSearchResults: false,
      initialLoaded: false
    };

    this.handleOnKeyDown = debounce(this.handleOnKeyDown, 300);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleShowResults, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleShowResults, false);
  }

  handleShowResults = (e) => {
    if (
      (
        e.target.className === 'search-jobs-input form-control' ||
        e.target.className === 'job-result ' ||
        e.target.className === 'job-result is-selected' ||
        e.target.className === 'job-is-selected' ||
        e.target.className === 'show-more-jobs btn btn-default'
      )
    ) {
      this.setState({ showSearchResults: true });
    } else {
      this.setState({ showSearchResults: false });
    }
  }

  handleSearch(cb, params = {}) {
    const { searchValue } = this.state;
    const { jobsSearch } = this.props;

    jobsSearch({ ...params, query: searchValue }, () => {
      this.setState({ showSearchResults: true }, () => {
        if (cb) cb();
      });
    });
  }

  handleSearchChange(e) {
    this.setState({ searchValue: e.target.value });
  }

  handleOnKeyDown() {
    this.handleSearch(null);
  }

  handleOnFocus() {
    const { initialLoaded } = this.state;
    if (!initialLoaded) {
      this.handleSearch(() => {
        this.setState({ initialLoaded: true });
      });
    }
  }

  handleNextPage(pageNumber) {
    const { jobSearchValue } = this.state;

    this.handleSearch(null, {
      page: pageNumber,
      query: jobSearchValue
    });
  }

  render() {
    const { jobs, addJob, removeJob, jobList, jobIsLoading } = this.props;
    const { searchValue, showSearchResults } = this.state;

    const jobResult = (job) => {
      return (
        <div>
          <div
            className={`job-result ${job.isSelected ? 'is-selected' : ''}`}
            onClick={() => {
              addJob(job);
            }}
          >
            <Row className='job-search-info'>
              <Col xs={6}>
                <h5>{job.title}</h5>
                <span className='job-sub-heading'>{job.company}</span>
                <span className='job-sub-heading'>{`${job.city}, ${job.state}, ${job.country}`}</span>
              </Col>
              <Col xs={6} style={{ textAlign: 'right' }}>
                <h5>Reference Number: {job.referencenumber}</h5>
                <br />
                <br />
              </Col>
            </Row>

            <Row>
              <hr style={{ marginTop: 0, marginBottom: '5px' }} />
            </Row>
          </div>
          {
            job.isSelected && <div
              className="job-is-selected"
              onClick={() => {
                removeJob(job);
              }}
              style={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                position: 'absolute',
                textAlign: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.5)'
              }}
            />
          }
        </div>
      );
    };

    const hasJobs = () => {
      return (
        <div>
          {jobList.map((job) => {
            return (
              <Row key={job.referencenumber}>
                <Col md={12}>
                  {jobResult(job)}
                </Col>
              </Row>
              );
          })}
          <Row>
            <Col xs={6} className="text-left">
              <Button 
                className='show-more-jobs' 
                disabled={!(jobs && jobs.meta && jobs.meta.pagination.prev_page)} 
                onClick={() => this.handleNextPage(jobs.meta.pagination.prev_page)}
              >
                Prev Page
              </Button>
            </Col>
            <Col xs={6} className='text-right'>
              <Button 
                className='show-more-jobs' 
                disabled={!(jobs && jobs.meta && jobs.meta.pagination.next_page)} 
                onClick={() => this.handleNextPage(jobs.meta.pagination.next_page)}
              >
                Next Page
              </Button>
            </Col>
          </Row>
        </div>
      );
    };
    
    const searchResults = () => {
      return (
        <div
          className={'job-search-results'}
          style={{
            position: 'absolute',
            backgroundColor: '#FFF',
            boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)',
            border: '1px solid #CCC',
            borderRadius: 3,
            marginLeft: '15px',
            marginRight: '15px',
            marginTop: '57px',
            padding: 10,
            zIndex: 999,
            width: '98%',
            maxHeight: '500px',
            overflowY: 'scroll',
            overflowX: 'hidden'
          }}
        >
          {
            jobList.length > 0 ? hasJobs() : 
            <Row>
              <Col className='text-center' xs={12}>
                  No Jobs were found with the search term provided.
              </Col>
            </Row>
          }
        </div>
      );
    };
    
    return (
      <Row>
        <Col md={12}>
          <ControlLabel>
            Job Inventory Search
          </ControlLabel>
        </Col>
        <Col md={12}>
          <FormControl
            componentClass='input'
            type='text'
            onKeyDown={this.handleOnKeyDown.bind(this)}
            value={searchValue}
            autoComplete={false}
            onChange={this.handleSearchChange.bind(this)}
            className='search-jobs-input'
            onFocus={this.handleOnFocus.bind(this)}
          />
        </Col>
        {
          showSearchResults && <div
            className='fade in'
          >
            {jobIsLoading ? <SearchJobsPlaceHolder /> : searchResults()}
          </div>
        }
      </Row>
    );
  }    
}

const mapStateToProps = (state) => {
  const {
    advertiser: {
      jobs: {
        data: jobs, loading: jobIsLoading
      }
    }
  } = state;

  return {
    jobs,
    jobIsLoading
  };
};

export default connect(mapStateToProps)(SearchJobs);
